export default __webpack_public_path__ + "static/media/AT-2020-16-3.72ebda02.png";